import React from 'react';
import Routes from "../../components/projects/routes/Routes";
import {QuicktHeader} from "../../base/header/QuicktHeader";

const ProjectsPage = () => {
    return (
        <>
            <QuicktHeader />
            <Routes />
        </>
    );
}

export default ProjectsPage;
